import { render } from "./ViewOffre.vue?vue&type=template&id=3dd2e335&ts=true"
import script from "./ViewOffre.vue?vue&type=script&lang=ts"
export * from "./ViewOffre.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__